// extracted by mini-css-extract-plugin
module.exports = {" _key":"sitepen-site/WhySitePen","image":"WhySitePen-m__image__f52bc31rSca","reverse":"WhySitePen-m__reverse__f52bc32gaqy"};